import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { User } from '@models/identity/user';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { plainToClass } from 'class-transformer';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[ifRoles]'
})
export class IfRolesDirective implements OnInit, OnDestroy {
  private subscription: Subscription[] = [];

  @Input() public ifRoles: Array<string>;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private authenticationService: AuthenticationService
  ) { }

  public ngOnInit(): void {
    this.subscription.push(
      this.authenticationService.getLoggedInUserAsObservable().subscribe(result => {
        if (result != null) { // TODO: Add API Return if no User is logged in
          var user = plainToClass(User, result);
          var roles = user.getRolesAsStringArray();

          if (!roles) {
            this.viewContainerRef.clear();
          }

          const idx = roles.findIndex((element) => this.ifRoles.indexOf(element) !== -1);
          if (idx < 0) {
            this.viewContainerRef.clear();
          } else {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
          }
        }
      })
    );
  }

  public ngOnDestroy(): void {
    this.subscription.forEach((subscription: Subscription) => subscription.unsubscribe());
  }
}
